import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useDispatch } from 'react-redux';

import { DocumentStr } from 'utils/Document';
import { ICustomer } from 'models/Customer';
import { ICustomerRole } from 'models/CustomerRole';

import { useOutsideClick } from 'hooks/useOutsideClick';

import arrowDropdown from 'img/arrow-dropdown.svg';

import { Visibility } from 'components/Visibility';

import './styles.scss';
import { SelectCustomerIdIsArray } from 'utils/SelectCustomerIdIsArray';

export const DropdownCustomers = (props: any) => {

  const { customersRoles, dropdown, selectedCustomerId } = props;

  const navigate = useNavigate();
  const location = useLocation();

  const [dropOpen, setDropOpen] = useState(false);
  const [dropdownCustomer, setDropdownCustomer] = useState(false);
  const [currentSelected, setCurrentSelected] = useState<Array<ICustomerRole>>([]);
  const dispatch = useDispatch();

  const wrapperRef = useRef(null);
  useOutsideClick(wrapperRef, setDropOpen);

  useEffect(() => {
    const selectCustomerIdFilter = customersRoles.filter((c: ICustomerRole) =>
      selectedCustomerId?.includes(c.customerId));

    setCurrentSelected(selectCustomerIdFilter.length > 0 ?
      selectCustomerIdFilter : customersRoles);
  }, [customersRoles]);

  useEffect(() => {
    if (dropdown && dropdownCustomer === false) return;

    let customerIds = customerIdByCurrentSelected();

    dispatch({
      type: 'SET_USER_CUSTOMER_ID',
      value: customerIds,
      madePurchaseIn: madePurshaseInArray()
    });

    dispatch({
      type: 'SET_VIEW_OPTIONS_DOWNLOAD_IN_LOT',
      value: false,
    });
  }, [currentSelected, dropdown]);

  const customerIdByCurrentSelected = () => {
    if (currentSelected?.length === 1)
      return currentSelected?.[0]?.customerId;

    if (currentSelected?.length > 1)
      return currentSelected?.map((current: ICustomerRole) => (current.customerId));
  };

  const madePurshaseInArray = () => {
    const codeMadePurshaseIn: Array<string> = [];

    currentSelected.forEach((current: ICustomerRole) => {
      codeMadePurshaseIn.push.apply(codeMadePurshaseIn, current?.madePurchaseIn!);
    });

    return Array.from(new Set(codeMadePurshaseIn));
  };

  const handlerSelected = (customer: Partial<ICustomer>) => {
    if (validateACompanyPage(customer)) return;

    setCurrentSelected(Array.isArray(customer) ? customer : [customer]);
    setDropdownCustomer(true);
    setDropOpen(false);
  };

  const validateACompanyPage = (customer: Partial<ICustomer>) => {
    if (location.pathname === '/dados-cliente' ||
      location.pathname === '/abrir-protocolo' ||
      location.pathname === '/politicas') {
      return SelectCustomerIdIsArray(customer);
    }
  };

  const isCheckedAll = () => {
    if (Array.isArray(selectedCustomerId)) {
      return customersRoles.filter((c: ICustomerRole) =>
        selectedCustomerId?.includes(c.customerId))?.length === customersRoles?.length;
    }

    return false;
  };

  const quantityLegalDocumentAllCustomer = () => {
    const legalDocument = customersRoles.map((c: ICustomerRole) => c.quantityLegalDocument);
    const totalLegalDocument = legalDocument.reduce((total: number, value: number) => {
      return total + value;
    }, 0);

    return totalLegalDocument > 0;
  };

  const goToCustomerData = () => {
    if (SelectCustomerIdIsArray()) return;
    navigate('dados-cliente');
  };

  const handlerCustomerList = () => {
    setDropOpen(!dropOpen);
  };

  const backgroundBtn = dropOpen ? 'customer-current--btn open' : 'customer-current--btn';

  const textMyEnterprise = currentSelected?.length > 1 ?
    "Minhas Empresas" : "Empresa Selecionada";

  return (
    <Visibility visible={!!customersRoles}>
      <div
        ref={wrapperRef}
        className="dropdown-customer dropdown-customer-mobile"
      >
        <span className="yellow-arrow">
          <img src={arrowDropdown} alt="Seta do dropdown de cliente" />
        </span>

        <div className="customer-current">
          <div onClick={() => goToCustomerData()}>
            <span>{textMyEnterprise}</span>
            <div className="customer-current--selected">
              {isCheckedAll() ? 'Todas as Empresas' :
                `${DocumentStr({
                  type: 'cnpj',
                  value: currentSelected[0]?.documentNumber!,
                })} | ${currentSelected[0]?.companyName} `
              }
            </div>
          </div>
          {customersRoles !== undefined && customersRoles.length > 1 && (
            <span className="btn-background">
              <button
                className={backgroundBtn}
                onClick={() => handlerCustomerList()}
              />
            </span>
          )}
        </div>

        <Visibility visible={dropOpen}>
          <div className="dropdown-customer--list">
            <ul>
              <li
                onClick={() => handlerSelected(customersRoles)}
                className={`${quantityLegalDocumentAllCustomer() ? 'dropdown-customer--alert' : ''}`}
              >
                TODAS AS EMPRESAS
              </li>
              {customersRoles !== undefined &&
                customersRoles.length > 1 &&
                customersRoles.map((customer: any, index: number) => (
                  <li
                    key={index}
                    className={customer.quantityLegalDocument > 0 ? 'dropdown-customer--alert' : ''}
                    onClick={() => handlerSelected(customer)}
                  >
                    {`${DocumentStr({
                      type: 'cnpj',
                      value: customer.documentNumber,
                    })} | ${customer.companyName} `}
                  </li>
                ))}
            </ul>
          </div>
        </Visibility>
      </div>
    </Visibility>
  );
};
